import { useState } from "react"
import { callApi } from "../../libs"

const useQuestionnaire = () => {
    const [questionnaire, setQuestionnaire] = useState({ isErr: true, status: 500, msg: "", data: null, statusCode: "STAND_BY" })
    const [submit, setSubmit] = useState({ isErr: true, status: 500, msg: "", data: null, statusCode: "STAND_BY" })
    const getQuestionnaireById = (id) => {
        const url = `${process.env.REACT_APP_API_COVID19_BACKOFFICE}/api/questionnaires/${id}`
        const method = 'get'
        callApi(method, url, null, null)
            .then(res => {
                // console.log(res.data)
                let questionnaire = res
                let newQ = questionnaire.data
                newQ.questions = newQ.questions.map(x => {
                    if (x.type === "text") x["answer"] = ""
                    // eslint-disable-next-line
                    x.options.map(y => {
                        y["answer"] = false
                    })
                    return x
                })
                setQuestionnaire({
                    ...questionnaire,
                    isErr: false,
                    statusCode: "GET_QUESTIONNAIRE_SUCCESS",
                    data: questionnaire.data
                })
            }).catch((error) => {
                // console.log(error)
                setQuestionnaire({
                    ...questionnaire,
                    statusCode: "GET_QUESTIONNAIRE_FAIL",
                    status: error.status,
                    data: error.response
                })
            })
    }

    const submitQuestionnaire = (questionnaireId, answers) => {
        console.log(`Questionnaire ID: ${questionnaireId}`)
        console.log(answers)
        const url = `${process.env.REACT_APP_API_COVID19_BACKOFFICE}/api/questionnaire-answers`
        const method = 'post'
        const body = {
            questionnaireId,
            answers
        }
        const headers = {
            Authorization: `Bearer ${localStorage.getItem("actk")}`
        }
        callApi(method, url, body, { headers })
            .then(res => {
                setSubmit({
                    ...submit,
                    data: res.data,
                    statusCode: "SUBMIT_QUESTIONNAIRE_SUCCESS"
                })
            }).catch((error) => {
                // console.log(error)
                setSubmit({
                    ...submit,
                    data: error.data,
                    statusCode: "SUBMIT_QUESTIONNAIRE_FAIL",
                    msg: error.msg,
                    status: error.status
                })
            })
    }

    return {
        getQuestionnaireById,
        submitQuestionnaire,
        questionnaire,
        setQuestionnaire,
        submit,
        setSubmit
    }
}

export default useQuestionnaire